import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { LightTheme } from "../ThemeLight";

import { styles } from "./ImageMediaImport.style";
import { getMediaTypeFromMimeType, MediaType, uploadMedia } from "../../Media";
import { litIf } from "../LitUtils";

@customElement("ds-image-media-import")
export class ImageMediaImport extends BaseElement {
    static override styles = [styles, LightTheme];

    @property({ type: String }) buttonText = "Import image";
    @property({ type: String }) iconName?: string;
    @property({ type: Number }) maxDimension?: number;
    @property({ type: Number }) maxSizeBytes?: number;

    @state() protected _uploadingMedia = false;
    @state() protected _uploadProgress = 0;

    private _showError(msg: string) {
        this._raiseEvent("ds-error", { error: msg });
    }

    private async _importFile(event: any) {
        this._uploadingMedia = true;
        try {
            if (event.target.files && event.target.files.length) {
                const file = event.target.files[0];
                if (file) {
                    const { type: mimeType, size } = file;
                    if (getMediaTypeFromMimeType(mimeType) !== MediaType.Image) {
                        this._showError(`Must be an image`);
                    } else if (this.maxSizeBytes && size > this.maxSizeBytes) {
                        this._showError(
                            `File too large. Maximum size is ${(this.maxSizeBytes / (1024 * 1024)).toFixed(2)}MB`
                        );
                    } else {
                        const result = await uploadMedia(file);
                        if (result && result.media) {
                            this._raiseEvent("ds-accept", { media: result.media });
                        }
                    }
                }
            }
        } catch (error: any) {
            this._showError(error);
        } finally {
            this._uploadingMedia = false;
            this._uploadProgress = 0;
        }
    }

    override render() {
        return html`<div>
            <sl-button @click=${() => this.shadowRoot?.getElementById("getResourceFile")?.click()}
                >${litIf(
                    this.iconName,
                    () => html`<sl-icon name=${this.iconName as string}></sl-icon>&nbsp;`
                )}
                ${this.buttonText}</sl-button
            >
            <input
                type="file"
                id="getResourceFile"
                style="display:none"
                @change=${this._importFile}
            />
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-image-media-import": ImageMediaImport;
    }
}
